/** API_SPEC.md §5 — tailor runs (job page, Tailor page, rebuild all produce one). */
import { api } from './client';
import type { GapQuestions, Paginated, TailorPageRequest, TailorPreview, TailorRun } from './types';

export const tailorApi = {
  run: (runId: string) => api<TailorRun>(`/v1/tailor-runs/${encodeURIComponent(runId)}`),
  history: (page = 1, perPage = 30) => api<Paginated<TailorRun>>('/v1/tailor-runs', { query: { page, per_page: perPage } }),
  /** Tailor page: creates a private job from the pasted description, then the run. */
  start: (body: TailorPageRequest, idempotencyKey: string) => api<TailorRun>('/v1/tailor-runs', { method: 'POST', body, idempotencyKey }),
  /** Re-attempts the 1-credit charge for a `locked` run (after a purchase). 402 if still short. */
  unlock: (runId: string) => api<TailorRun>(`/v1/tailor-runs/${encodeURIComponent(runId)}/unlock`, { method: 'POST' }),
  cancel: (runId: string) => api<TailorRun>(`/v1/tailor-runs/${encodeURIComponent(runId)}/cancel`, { method: 'POST' }),
  /** A rebuild's Gap questions with server-derived progress; the resume point after a reload. */
  questions: (runId: string) => api<GapQuestions>(`/v1/tailor-runs/${encodeURIComponent(runId)}/questions`),
  answerQuestion: (runId: string, questionId: string, answer: string) =>
    api<GapQuestions>(`/v1/tailor-runs/${encodeURIComponent(runId)}/questions/${encodeURIComponent(questionId)}/answer`, { method: 'POST', body: { answer } }),
  skipQuestion: (runId: string, questionId: string) =>
    api<GapQuestions>(`/v1/tailor-runs/${encodeURIComponent(runId)}/questions/${encodeURIComponent(questionId)}/skip`, { method: 'POST' }),
  /** Ends the questions and starts generating; the 1 credit is reserved here (402 at the third withheld run, answers kept). */
  finishQuestions: (runId: string) => api<TailorRun>(`/v1/tailor-runs/${encodeURIComponent(runId)}/questions/finish`, { method: 'POST' }),
  /**
   * What each level would do to this resume for this job (ticket 22).
   * Free: no model call, no credit reserved, no run created — so the picker
   * can describe the work before anyone pays for it. Pass the same
   * resumeId/uploadId the start request will, or the card describes a
   * different document from the one that gets rewritten.
   */
  preview: (jobId: string, source?: { resumeId?: string; uploadId?: string }) =>
    api<TailorPreview>(`/v1/jobs/${encodeURIComponent(jobId)}/tailor-preview`, { query: { resumeId: source?.resumeId, uploadId: source?.uploadId } }),
};

export const isTerminal = (r: TailorRun | undefined | null) => !!r && (r.status === 'succeeded' || r.status === 'failed');
